<template>
  <a-modal v-model="downloadShowFun"
           title="下载数据"
           ok-text="确定"
           cancel-text="取消"
           @ok="submitForm('ruleForm')"
           @cancel="resetForm('ruleForm')"
           class="downloadFrame"
           width="440">

    <a-form-model ref="ruleForm"
                  :model="ruleForm"
                  :rules="rules"
                  v-bind="layout"
                  class="formFrame">

      <a-form-model-item label="监测点名称"
                         class="formItemText">
        <p>{{more?'(表格中已选设备)':downData.name}}</p>
      </a-form-model-item>

      <a-form-model-item label="设备名称"
                         class="formItemText">
        <p>{{more?'(表格中已选设备)':downData.name}}</p>
      </a-form-model-item>

      <a-form-model-item label="数据频率"
                         prop="dateChoose">
        <a-select v-model="ruleForm.dateChoose"
                  placeholder="时均值">
          <a-select-option value="时均值">
            时均值
          </a-select-option>
          <a-select-option value="日均值">
            日均值
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="选择参数"
                         prop="params">
        <a-select v-model="param"
                  placeholder="请选择参数"
                  mode="multiple" @change="handleChange">
          <a-select-option v-for="(p,index) in params" :value="p" :key="index">
            {{p}}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 时间区间-时区间 -->
      <a-form-model-item label="时间区间"
                         prop="dateGroup"
                         class="chooseDate">
        <!-- 日期 年-月-日 -->
        <a-range-picker @change="onChangeDate"
                        :default-value="[moment(ruleForm.startDate, dateFormat), moment(ruleForm.endDate, dateFormat)]"
                        :model="ruleForm.dateGroup"
                        :disabled-date="disabledDate"
                        :getCalendarContainer="(triggerNode) => triggerNode.parentNode">
          <a-icon slot="suffixIcon"
                  type="calendar" />
        </a-range-picker>
      </a-form-model-item>

      <!-- 检测失败图标 -->
    </a-form-model>

  </a-modal>

</template>
<script>
import moment from 'moment'
import Com from '@/common/js/com.js'
import { requestData } from '@/common/js/commont.js'
import MixinSD from '@/store/sd/mixinsSd.js'
import ExportExcel from '@/export/index.js'
export default {
  mixins: [MixinSD],
  props: ['downloadShow', 'downData', 'more', 'moreCode', 'moreData', 'params'], /* downloadShow: 下载框显示状态   downData: 当前选择的数据列 */
  data () {
    return {
      //   id: 'inputFile',
      dateFormat: 'YYYY-MM-DD',
      param: '',
      arguments: '',
      download: '1',
      ruleForm: {
        dateChoose: '', // 数据频率选择
        dateChooseId: '',
        address: '', // 下载地址
        startDate: null, // 日均值
        endDate: null, // 日均值
        dateGroup: [null, null] // 日期区间
      },
      rules: {
        // address: [{ validator: validatePass, trigger: 'change' }], // 下载地址
        // dateGroup: [{ validator: validatePass, trigger: 'change' }] // 选择日期
      },
      layout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 }
      }
    }
  },
  created () {
    this.timeList = Com.timeList
    this.ruleForm.dateChoose = Com.timeDefaultName
    this.ruleForm.dateChooseId = Com.timeDefault
    var start = Com.getBeforeDate(7, 'date')
    var end = Com.getBeforeDate(0, 'date')
    this.ruleForm.startDate = start
    this.ruleForm.endDate = end
  },
  methods: {
    moment,
    disabledDate: function (current) { // 日期禁止
      return current && current > moment().endOf('day') // 不能今天之后的日期
    },
    chooseDateIdFun: function (val) {
      if (val === '时均值') {
        return 'H'
      } else {
        return 'D'
      }
    },
    onChangeDate: function (date, dateString) { // 日均值日期选择
      const num = Com.dateDiff(dateString[0], dateString[1])
      if (num > 366) {
        this.$message.warning('最多只可以选择一年！')
      } else {
        this.ruleForm.startDate = dateString[0]
        this.ruleForm.endDate = dateString[1]
      }
    },
    resetForm: function (formName) { /* 关闭-下载弹框 */
      this.$refs[formName].resetFields()
      this.$emit('hideDownModal', false)
    },
    submitForm: function (formName) { /* 确定-下载弹框 */
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.getDeviceLogList()
        } else {
          return false
        }
      })
    },
    getDeviceLogList: function () {
      // 修改时间格式
      var minTime, maxTime
      const dateChooseId = this.chooseDateIdFun(this.ruleForm.dateChoose)
      const time = Com.stringTime((new Date()), 'time')
      minTime = (this.ruleForm.startDate) + time
      maxTime = (this.ruleForm.endDate) + time
      var ts = Com.stringTime(new Date())
      console.log(maxTime)
      var data = {
        account: window.localStorage.getItem('account'),
        arguments: this.arguments,
        codes: this.more ? this.moreCode.join(',') : this.downData.code,
        datetype: dateChooseId,
        download: this.download,
        max_time: maxTime,
        min_time: minTime,
        // param: this.more ? this.param : '',
        token: window.localStorage.getItem('token'),
        ts
      }
      const that = this
      that.$message.success('表格写入中请稍等...')
      window.location = 'http://air.airdaas.com/api/devicelog/downloadDeviceLog?'+requestData(data)
      // this.getDeviceLogListSD(data).then(function (value) {
      //   const result = value.data.data
      //   if (result.params && result.list) {
      //     that.getData(result, that)
      //   } else {
      //     that.$message.success('下载失败，稍后再试！')
      //   }
      // })
    },
    getData: function (result, that) {
      const liTable = that.downData
      var columns
      if (this.more) {
        var title
        if (this.param === 'CO' || this.param === 'CO2') {
          title = this.param + 'mg/m³'
        } else {
          title = this.param + 'μg/m³'
        }
        columns = [
          { key: 'dname', title: '设备名' },
          { key: 'code', title: '设备识别号' },
          { key: 'time', title: '更新时间' },
          { key: this.param, title: title }
        ]
      } else {
        columns = result.params.map(item => ({ key: item.name, title: (item.name === 'CO' || item.name === 'CO2') ? item.name + 'mg/m³' : item.name + 'μg/m³' }))
        columns.unshift({ key: 'typename', title: '设备类型名称' })
        columns.unshift({ key: 'dname', title: '设备名称' })
        columns.push({ key: 'time', title: '更新时间' })
      }

      const dataSource = result.list.map(item => {
        Object.keys(item).forEach(key => { // 后端传null node写入会有问题
          if (item[key] === null) {
            item[key] = ''
          }
          if (Array.isArray(item[key])) {
            item[key] = item[key].join(',')
          }
          if (!this.more) {
            item.typename = (liTable.typename)
            item.dname = (liTable.dname)
          } else {
            this.moreData.forEach(code => {
              if (code.code === item.code) {
                item.dname = code.dname
              }
            })
          }
        })
        return item
      })
      const start = (this.ruleForm.startDate).replace(/-/g, '')
      const end = (this.ruleForm.endDate).replace(/-/g, '')
      if (this.more) {
        ExportExcel(columns, dataSource, `${start}-${end}_多设备_${this.param}_导出.xlsx`)
      } else {
        ExportExcel(columns, dataSource, `${start}-${end}_${liTable.name}_导出.xlsx`)
      }
      // ExportExcel(columns, dataSource, `${new Date().getTime().toString()}_${liTable.code}_导出.xlsx`)
    },
    handleChange(v) {
      let y = v.join(',')
      this.arguments = y
      console.log('选择',this.arguments)
    }
  },
  computed: {
    downloadShowFun: {
      get: function () {
        return this.downloadShow
      },
      set: function () {
        return !this.downloadShow
      }
    }
  },
  watch:{
    params(val) {
      // 若有pm2.5则取，否则取第一参
      let isExist = this.params.filter(i=>(i== 'PM2.5'|| 'pm2.5'))
      if(isExist) {
        this.param = 'PM2.5'
        this.arguments = 'PM2.5'
      } else {
        this.param = this.params[0]
        this.arguments = this.params[0]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.timeGroup {
  display: flex;
  align-items: center;
}
.timeGroup > span {
  font-size: 0.14rem;
  color: rgba(0, 0, 0, 0.65);
  width: 0.3rem;
  text-align: center;
}
</style>
